<div>
  <b>Project Name</b>
  <br/>
  <dw-readonly [(ngModel)]="selectedString" formatType="string"></dw-readonly>
</div>
